import { Component, OnInit } from '@angular/core';
import { CongressOption, Modal } from 'src/app/models';
import { CommonService, ModalService, StateService } from 'src/app/services';
import { environment } from '../../../environments/environment';
import boothData from '../../data/booths.json';
import modalData from '../../data/modals.json';

@Component({
    selector: 'app-leaving',
    templateUrl: './leaving.component.html',
    styleUrls: ['./leaving.component.scss']
})
export class LeavingComponent implements OnInit {
    constructor(
        private modalSvc: ModalService,
        private stateSvc: StateService,
        private commonSvc: CommonService
    ) { }

    ngOnInit(): void {
    }

    public continue(): void {
        this.commonSvc.setMedInfoLink();
        const data: Modal = modalData.find(el => el.id === 'medical-info');
        window.open(data.iframe ? data.iframe : 'https://www.medinfo.bayer.com/');

        setTimeout(() => {
            this.modalSvc.hideModal();
        }, 250);
    }

    public goBack(): void {
        this.modalSvc.hideModal();
    }
}
